<template>
    <div class="page_loader_cont" v-if="page_loading">
         <div class="spinner_height">
            <spinner-circle :black="true"></spinner-circle>
        </div>
    </div>

    <div v-if="($route.params.id === 'bv' || $route.params.id === 'ph') && show_phone_screen" class="rate_branch_cont">


    <div class="row  home_comp_cont">
      <div v-if="show_reset_form && phone__" class="delete_cont">
        <div class="delete_cont_2">
          <div class="delete_heading">If you go back you will lose all the data you have entered !</div>
          <div  class="row btn_del_cont">
            <button @click="close_reset_form_prompt()" class="pop_btn cencel_btn">Cencel</button>
            <button class="pop_btn delete_btn">
              <div @click="reset_form_()">Go Back</div>
            </button>
          </div>
        </div>
      </div>
        <div class="left">
          <img class="row img" :src="linkk + '/' + 'logo2.png'" alt="logo">
          <div class=" powered_by_customer">
            powered by 
            <router-link to="/pharaohfrog"  class="ph_link"><b>pharaoh frog</b></router-link>
          </div>
        </div>
        <div class="right">
            <h1 v-if="$route.params.id === 'bv'" class="hone hone_link rating_h1">Rate beverly hills branch</h1>
            <h1 v-if="$route.params.id === 'ph'" class="hone hone_link rating_h1">Rate palm hills branch</h1>
            
            <div class="back_cont">
              <!-- <router-link class="col back_btn_mini" class-active="active" to="/" >back</router-link> -->
              <!-- <div @click="open_reset_form_prompt()" class="col back_btn_mini" class-active="active" to="/" >back</div> -->
                <form class="row btn_home_cont">
                  <input type="tel" placeholder="Phone" class="input" v-model="phone__"   @focus="magic_flag = true" @blur="magic_flag = false">
                  <!-- <button class="btn btn_first_grooming" @click.prevent="from_step_1()" >Next</button> -->
                    <button :class=" phone_loading ? 'btn btn_first_grooming no_padding' : 'btn btn_first_grooming' "
                    @click.prevent="ratting_by_phone()">
                      <div class="loading" v-if="phone_loading" >
                        <Spinner/>
                      </div>
                      <div class="btn_txt" v-else >Next</div>
                    </button>

                  <!-- <button class="btn btn_first_grooming" @click="$router.push('/grooming/step-2')">Next</button> -->
                </form>

                <!-- add skip btn as secondary option with style matching the design -->
                <button class="btn btn_skip" @click.prevent="skip_phone_ratting()">Skip</button>

              <div v-if="error" class="err_single_line">{{ error }}</div>
            </div>
        </div>
        <div v-if="line !== null && magic_flag === false" class="waiting_line waiting_line__">waiting: {{line}}</div>
        <button  v-if="role === 'customer'" @click.prevent="logout()" class="waiting_line logout_">
            <spinner :black="true" v-if="logout_loading"></spinner>
            <div v-else-if="magic_flag === false">logout</div>
        </button>
    </div>


    </div>

    <div v-if="(ratings && !already_rated && !show_thanks_for_rating) || (no_phone_r && !show_thanks_for_rating)" class="conttte">
        <!-- Header -->
        <div class="header">
            <img v-if="ratings.company_logo" class="row img rating_logo" :src="linkk + '/' + ratings.company_logo" alt="logo">

            <p class="title">
                please rate the the employee<br />
                that serverd you :
            </p>
            <!-- <h3 class="branch" v-if="ratings.title">{{ ratings.title }}</h3> -->
            <!-- Custom-coded by Haroon with cool style to make people call me for projects-->
            <!-- <div class="call_haroon">Custom-coded by Haroon</div> -->
            <!-- dev phone -->
            <!-- <div class="dev_phone">call the developer: +20 109 460 2675</div> -->
             <div class="contact_us ">
                Contact the developer?
                <a class="dev_phone_link" href="tel:+201094602675" >+20 109 460 2675</a>
             </div>
           
        </div>
        <div class="column rating-page">

            <!-- branch rating -->
            <div v-if="ratings.company_logo && ratings.title" class="rating-card">
                <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${ratings.company_logo})` }"></div>

                <div class="info">
                    <div class="name-row">

                        <div class="name_and_role_and_stars_cont">
                            <div>
                                <h4 class="h_4_edit">{{ ratings.title }}</h4>
                            </div>
                            <!-- Stars -->
                            <StarsComp_ v-model="branch_rating_" @rated="branch_send_rating" />
                        </div>



                        <div class="row score none" v-if="!no_phone_r">
                            <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                            <div class="column">
                                <div v-if="ratings.branch_ratings.amazon_rating" class="rate_avg">{{ ratings.branch_ratings.amazon_rating }}</div>
                                <div v-else class="rate_avg">--</div>
                                <div v-if="ratings.branch_ratings.total_reviews" class="total_ratings">({{ ratings.branch_ratings.total_reviews }})</div>
                                <div v-else class="total_ratings">(--)</div>
                            </div>
                        </div>
                    </div>



                    <!-- Comment -->
                     <!--  v-model="item.comment" -->
                    <textarea v-model="branch_comment_" class="comment" placeholder="comment"></textarea>
                </div>
            </div>


            <!-- sales rating -->
            <div v-if="ratings.sales_user" class="rating-card">
                <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${ratings.sales_user.profile_pic})` }"></div>

                <div class="info">
                    <div class="name-row">

                        <div class="name_and_role_and_stars_cont">
                            <div>
                                <h4 class="h_4_edit">{{ ratings.sales_user.name }}</h4>
                                <span class="role" >Sales</span>
                            </div>
                            <!-- Stars -->
                            <StarsComp_ v-model="sales_rating_" @rated="sales_send_rating" />
                        </div>


                        <div class="row score none">
                            <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                            <div class="column">
                                <div v-if="ratings.sales_user.sales_ratings.amazon_rating" class="rate_avg">{{ ratings.sales_user.sales_ratings.amazon_rating }}</div>
                                <div v-else class="rate_avg">--</div>
                                <div v-if="ratings.sales_user.sales_ratings.total_reviews" class="total_ratings">({{ ratings.sales_user.sales_ratings.total_reviews }})</div>
                                <div v-else class="total_ratings">(--)</div>
                            </div>
                        </div>
                    </div>



                    <!-- Comment -->
                     <!--  v-model="item.comment" -->
                    <textarea v-model="sales_comment_" class="comment" placeholder="comment"></textarea>
                </div>
            </div>


            <!-- groomer rating -->
             <!-- loop for multi-groomers -->

             <div v-if="clean_groomers && clean_groomers.length > 0" class="multi_groomers_cont">
                <div v-for="(groomer, index) in clean_groomers" :key="groomer.id" class="rating-card">
                    
                    <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                    <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${groomer.profile_pic})` }"></div>

                    <div class="info">
                        <div class="name-row">

                            <div class="name_and_role_and_stars_cont">
                                <div>
                                    <h4 class="h_4_edit">{{ groomer.name }}</h4>
                                    <span class="role" >Groomer</span>
                                    <!-- loop in pets -->
                                    <div v-for="pet in groomer.pets" :key="pet.name" class="grooming_deatils">
                                        <span>{{ pet.name }}</span>
                                        <span v-if="pet.service === 1"> - Handled all requested services</span>
                                        <span v-else> - {{ pet.service }}</span>
                                    </div>
                                </div>
                                <!-- Stars -->
                                <StarsComp_ v-model="groomer_rating_" @rated="groomer_send_rating(index)" />

                            </div>


                            <div class="row score none">
                                <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                                <div class="column">
                                    <!-- <div v-if="groomer.groomer_ratings.amazon_rating" class="rate_avg">{{ groomer.groomer_ratings.amazon_rating }}</div>
                                    <div v-else class="rate_avg">--</div>
                                    <div v-if="groomer.groomer_ratings.total_reviews" class="total_ratings">({{ groomer.groomer_ratings.total_reviews }})</div>
                                    <div v-else class="total_ratings">(--)</div> -->
                                </div>
                            </div>
                        </div>



                        <!-- Comment -->
                        <!--  v-model="item.comment" -->
                        <textarea v-model="groomer.comment" class="comment" placeholder="comment"></textarea>
                    </div>
                </div>
            </div>



            <!-- Cashier rating -->
            <div v-if="ratings.cashier_user" class="rating-card">
                <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${ratings.cashier_user.profile_pic})` }"></div>

                <div class="info">
                    <div class="name-row">

                        <div class="name_and_role_and_stars_cont">
                            <div>
                                <h4 class="h_4_edit">{{ ratings.cashier_user.name }}</h4>
                                <span class="role" >Cashier</span>
                            </div>
                            <!-- Stars -->
                            <StarsComp_ v-model="cashier_rating_" @rated="cashier_send_rating" />
                        </div>


                        <div class="row score none">
                            <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                            <div class="column">
                                <div v-if="ratings.cashier_user.cashier_ratings.amazon_rating" class="rate_avg">{{ ratings.cashier_user.cashier_ratings.amazon_rating }}</div>
                                <div v-else class="rate_avg">--</div>
                                <div v-if="ratings.cashier_user.cashier_ratings.total_reviews" class="total_ratings">({{ ratings.cashier_user.cashier_ratings.total_reviews }})</div>
                                <div v-else class="total_ratings">(--)</div>
                            </div>
                        </div>
                    </div>



                    <!-- Comment -->
                     <!--  v-model "item.comment" -->
                    <textarea v-model="cashier_comment_" class="comment" placeholder="comment"></textarea>
                </div>
            </div>



            <!-- Example usage of your data -->
            <!-- <div v-if="loading" class="loading">Loading...</div> -->
            <div v-if="error" class="error_msg d_error_msg">{{ error }}</div>


            <div class="row bts_cont">

                <button class="submit backk" :disabled="logout_loading || submit_loading" @click="back_to_phone_screen()">
                    <div class="btn_txt" >Back</div>
                </button>
            
                <button class="submit" :disabled="logout_loading" @click="submitRatings">
                    <div class="loading" v-if="submit_loading">
                        <Spinner />
                    </div>
                    <div class="btn_txt" v-else>Submit</div>
                </button>

            </div>


        </div>
    </div>
   <div v-if="ratings && already_rated && !show_thanks_for_rating" class="column already_rated_cont">
        <div class="column status-card already_rated" id="ratedSection">

            <!-- <div class="status-card__icon">⭐</div> -->

            <h2 class="status-card__value">
                Already Rated
            </h2>

            <div class="status-card__subtitle">
                You have already rated this session.
            </div>

            <!-- <button class="status-card__action close_the_tab" @click="close_the_tab()">
                Close
            </button> -->

        </div>
    </div>

    <div v-if="show_thanks_for_rating" class="home_3">
        <ThanksForRating  />
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';
// import { mapActions } from 'vuex';
import request from '../axios_request';
// import Spinner from '@/components/Spinner.vue';
// import SocketioService from '@/services/socketio.service.js';
import StarsComp_ from '@/components/StarsComp_.vue';
import ThanksForRating from "@/components/ThanksForRating.vue";
import SpinnerCircle from './SpinnerCircle.vue';
import Spinner from '@/components/Spinner.vue';



export default {
    name: 'EmployeeRating',
    components: {
        StarsComp_,
        ThanksForRating,
        SpinnerCircle,
        Spinner
    },

    data() {
        return {
            page_loading: true,
            /* 🔹 YOUR DATA */
            already_rated: false,
            phone__: null,
            // loading: false,
            error: null,
            show_reset_form: false,
            line: null,
            linkk: process.env.VUE_APP_SERVER_ENDPOINT,
            logout_loading: false,
            magic_flag: false,
            rating_id__: null,

            ratings: null,
            branch_rating_: 0,
            branch_comment_: null,
            sales_rating_: 0,
            sales_comment_: null,
            groomer_rating_: 0,
            groomer_comment_: [],
            cashier_rating_: 0,
            cashier_comment_: null,

            show_thanks_for_rating: false,
            submit_loading: false,
            no_phone_r: false,
            show_phone_screen: false,
            phone_loading: false
        }
    },

    // mounted() {
    //     this.rating_id__  = this.$route.params.id;
    //     console.log('Rating ID:', this.rating_id__);
    // },

    created() {
        this.rating_id__  = this.$route.params.id;
        console.log('Rating ID:', this.rating_id__);
        // check ratind_id__ is not null then fetch data from server
        if (this.rating_id__ && this.rating_id__ !== null) {

            if(this.rating_id__ === 'bv'){
                this.show_phone_screen = true;
                console.log('B.V. content');
                this.page_loading = false;
                return;
            }

            if(this.rating_id__ === 'ph'){
                this.show_phone_screen = true;
                console.log('palm hills content');
                this.page_loading = false;
                return;
            }

            // Fetch rating data from server using rating_id__ send it as post request with rating_id__ = url_id
            console.log('Fetching rating data for ID:', this.rating_id__);
            // Example: You can use axios or fetch to get data from server
            request.post('/api/rating/get_by_url_id', { url_id: this.rating_id__ })
                .then(response => {
                    console.log('Response from server:', response.data);
                    // Assuming response.data contains the ratings data
                    this.ratings = response.data;
                    console.log('Fetched rating data:', response);
                    console.log('--------------------:', this.clean_groomers, '-------------------');
                    console.log('--------------------:', this.ratings.submitted, '-------------------');
                    if((this.ratings.submitted && this.ratings.submitted === true || (this.ratings.submitted && this.ratings.submitted === 1))){
                        this.already_rated = true;
                    }
                    this.page_loading = false;
                })
                .catch(error => {
                    console.error('Error fetching rating data:', error);
                    this.error = 'Failed to load rating data. Please try again later.';
                    this.page_loading = false;
                });


        }









    },
    computed: {
        ...mapState([
            'phone',
            'parent_id',
            'first_time',
            'parent_name',
            'role',
            'company_logo'
        ]),

        clean_groomers(){
            var c_groomers = [];
            if(this.ratings && this.ratings.groomers && this.ratings.groomers.length > 0){
                //loop for ratings.groomers
                this.ratings.groomers.forEach(groomer => {
                    var found = c_groomers.find(g => g.id === groomer.id);
                    if(!found){
                        c_groomers.push({
                            id: groomer.id,
                            name: groomer.name,
                            profile_pic: groomer.profile_pic,
                            ratingData: [groomer.ratingData],
                            pets: []
                        });

                        //now check if multi_groomers inside groomer exist then loop through it
                        
                        if(groomer.multi_groomers && groomer.multi_groomers.length > 0){
                            //now convert to vaild json and loop through it
                            if(!Array.isArray(groomer.multi_groomers)){
                                try {
                                    groomer.multi_groomers = JSON.parse(groomer.multi_groomers);
                                } catch (e) {
                                    console.error('Error parsing multi_groomers for groomer:', groomer.id, e);
                                    groomer.multi_groomers = [];
                                }
                            }
                            groomer.multi_groomers.forEach(mg => {
                                if( mg.groomer_id === groomer.id ){
                                    c_groomers[c_groomers.length - 1].pets.push({
                                        name: groomer.pet_name,
                                        service: mg.service
                                    });
                                }
                            });
                        }else{
                            // if service is one that means this groomer did a whole grooming for this pet
                            c_groomers[c_groomers.length - 1].pets.push({
                                name: groomer.pet_name,
                                service: 1
                            });
                        }

                    }else{



                        //now check if multi_groomers inside groomer exist then loop through it
                        
                        if(groomer.multi_groomers && groomer.multi_groomers.length > 0){
                            //now convert to vaild json and loop through it
                            if(!Array.isArray(groomer.multi_groomers)){
                                try {
                                    groomer.multi_groomers = JSON.parse(groomer.multi_groomers);
                                } catch (e) {
                                    console.error('Error parsing multi_groomers for groomer:', groomer.id, e);
                                    groomer.multi_groomers = [];
                                }
                            }

                            groomer.multi_groomers.forEach(mg => {
                                if( mg.groomer_id === groomer.id ){
                                    // now find the groomer in c_groomers with id = groomer.id and push the pet to it
                                    var found_groomer = c_groomers.find(g => g.id === groomer.id);
                                    if(found_groomer){
                                        found_groomer.ratingData.push(groomer.ratingData);
                                        found_groomer.pets.push({
                                            name: groomer.pet_name,
                                            service: mg.service
                                        });
                                    }
                                }
                            });

                        }else{
                            // if service is one that means this groomer did a whole grooming for this pet
                            //now get the groomer from c_groomers with id = groomer.id and push the pet to it
                            var found_groomer = c_groomers.find(g => g.id === groomer.id);
                            if(found_groomer){
                                found_groomer.ratingData.push(groomer.ratingData);
                                found_groomer.pets.push({
                                    name: groomer.pet_name,
                                    service: 1
                                });
                            }
                        }



                    }
                });
            }
            return c_groomers;
        }

    },

    methods: {
        ...mapActions([
            "phone_",
            "parent_name_",
            "parent_id_",
            "first_time_",
            'set_logged_in',
            'role_',
            'company_logo_',
            'admin_name_'
        ]),
        branch_send_rating(value) {
            console.log('User rated Branch:', value)
        },
        sales_send_rating(value) {
            console.log('User rated Sales:', value)
        },
        groomer_send_rating(index) {
            console.log('User rated Groomer:', this.groomer_rating_);
            //loop though this.clean_groomers[index].ratingData and add ratins = this.groomer_rating_ to each item in it
            if( this.clean_groomers && this.clean_groomers[index] && this.clean_groomers[index].ratingData && this.clean_groomers[index].ratingData.length > 0 ){
                this.clean_groomers[index].ratingData.forEach(item => {
                    item.rating = this.groomer_rating_;
                });
            }
            console.log('Updated ratingData for groomer:', this.clean_groomers[index].ratingData);

        },
        cashier_send_rating(value) {
            console.log('User rated Cashier:', value)
        },
        onRated(value) {
            console.log('rating =', value)
            // هنا تبعت API
        },
        submitRatings() {
            if( this.submit_loading ){
                return;
            }
            this.error = null;
            this.submit_loading = true;




            //check if the route params id is bv or ph then only branch rating is required and the rest of the ratings are not required
            if( this.$route.params.id === 'bv' || this.$route.params.id === 'ph' ){
                // only branch rating is required
                if( !this.branch_rating_ ) {
                    this.error = 'Please provide a rating for the branch before submitting.';
                    this.submit_loading = false;
                    return;
                }
                var branch_name = null;

                if(this.$route.params.id === 'bv'){
                    branch_name = 'beverly_hills';
                }else if(this.$route.params.id === 'ph'){
                    branch_name = 'palm_hills';
                }

                if(!branch_name){
                    this.error = 'Invalid branch. Please try again later.';
                    this.submit_loading = false;
                    return;
                }

                //now send the payload with only branch rating and comment
                var ratings_payload_no_phone = {
                    branch_rate: this.branch_rating_,
                    branch_comment: this.branch_comment_,
                    branch: branch_name
                };

                if( this.phone__ ){
                    ratings_payload_no_phone.phone = this.phone__;
                }

                // console.log('Submitting ratings payload:', ratings_payload);
                // Send the payload to the API
                request.post('/api/rating/submit_rating', ratings_payload_no_phone)
                .then(response => {
                    console.log('Ratings submitted successfully:', response);
                    this.show_thanks_for_rating = true;
                })
                .catch(error => {
                    console.error('Error submitting ratings:', error);
                    this.error = 'Failed to submit ratings. Please try again later.';
                    this.submit_loading = false;
                });

                return;
            }






            if( !this.branch_rating_ || !this.sales_rating_ || !this.groomer_rating_ || !this.cashier_rating_ ) {
                this.error = 'Please provide ratings for all categories before submitting.';
                this.submit_loading = false;
                return;
            }

            var ratings_payload = {
                url_id: this.rating_id__,
                branch_rate: this.branch_rating_,
                branch_comment: this.branch_comment_,
                sale_rate: this.sales_rating_,
                sales_comment: this.sales_comment_,
                cashier_rate: this.cashier_rating_,
                cashier_comment: this.cashier_comment_,

                groomers_data: []
            };

            if(this.clean_groomers && this.clean_groomers.length > 0){
                this.clean_groomers.forEach(groomer => {
                    ratings_payload.groomers_data.push({
                        groomer_id: groomer.id,
                        // sessions_id: groomer.ratingData && groomer.ratingData.length > 0 ? groomer.ratingData[0].session_id : null,
                        // loop in groomer.ratingData and get session_id in arr
                        session_ids: groomer.ratingData ? groomer.ratingData.map(r => r.session_id) : [],
                        rating: groomer.ratingData && groomer.ratingData.length > 0 ? groomer.ratingData[0].rating : this.groomer_rating_,
                        comment: groomer.comment ? groomer.comment : null
                    });
                });
            }

            console.log('Submitting ratings payload:', ratings_payload);



            // now submit all ratings and comments to server on this url /api/rating/submit_rating
            // send post request with branch_rating_, branch_comment_, sales_rating_, sales_comment_, groomer_rating_, groomer_comment_, cashier_rating_, cashier_comment_
            request.post('/api/rating/submit_rating', ratings_payload)
            .then(response => {
                console.log('Ratings submitted successfully:', response);
                // alert('Thank you for your feedback!');
                this.show_thanks_for_rating = true;
                this.already_rated = true;
                // Optionally, redirect or clear the form
            })
            .catch(error => {
                console.error('Error submitting ratings:', error);
                this.error = 'Failed to submit ratings. Please try again later.';
                this.submit_loading = false;
            });

        },
        close_the_tab() {
            window.location.href = "about:blank";
            // window.close();
        },
        skip_phone_ratting() {
            //now show only rate the branch only
            this.no_phone_r = true;
            console.log('Skipping phone ratting, showing only branch rating.');
            var title = '';
            if(this.$route.params.id === 'bv'){
                title = 'Beverly Hills Branch';
            }else if(this.$route.params.id === 'ph'){
                title = 'Palm Hills Branch';
            }
            this.ratings = {
                company_logo: 'logo2.png',
                title: title
            };

            this.show_phone_screen = false;
            
        },

        back_to_phone_screen() {
            this.show_phone_screen = true;
            this.no_phone_r = false;
            this.ratings = null;
        },

        ratting_by_phone() {
            if( this.phone_loading ){
                return;
            }
            this.error = null;
            this.phone_loading = true;

            if(!this.phone__){
                this.error = 'Please enter your phone number.';
                this.phone_loading = false;
                return;
            }

            //check :id and send it as branch name to the server as branch_name

            let branch_name = '';
            if(this.$route.params.id === 'bv'){
                branch_name = 'beverly_hills';
            }else if(this.$route.params.id === 'ph'){
                branch_name = 'palm_hills';
            }else{
                this.error = 'Invalid branch. Please try again later.';
                this.phone_loading = false;
                return;
            }

            // send post request to /api/rating/check_phone_rating with phone__ and url_id
            request.post('/api/rating/check_phone_rating', { phone: this.phone__, url_id: this.rating_id__, branch: branch_name })
                .then(response => {
                    console.log('Response from server:', response.data);

                    if(response.data && response.data.url_id){
                        //get bv or ph from the current url
                        const branch_id = this.$route.params.id;

                        //route to the same page with the url_id from the response and reload the page to fetch the ratings data for that url_id
                        const url = this.$router.resolve({
                            name: 'ratting_front_client',
                            params: {
                                id: response.data.url_id
                            },
                            query: {
                                y: branch_id
                            }
                        }).href;
                        console.log('Redirecting to URL:', url);

                        window.location.href = url;
                        
                    }else{
                        //add phone to ratings table and show the branch rating only
                        this.skip_phone_ratting();
                        console.log('Phone not found, showing only branch rating.');
                    }


                    this.show_phone_screen = false;
                    this.phone_loading = false;
                })
                .catch(error => {
                    console.error('Error fetching rating data by phone:', error);
                    this.error = 'Failed to load rating data. Please try again later.';
                    this.phone_loading = false;
                });
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700;800&display=swap');

.conttte{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Nunito', Arial, sans-serif;
    margin: 50px 0px;
}

.rating-page {
    max-width: 500px;
    width: 90%;
    margin: auto;
    padding: 20px;
    /* font-family: Arial, sans-serif; */
    background-color: white;
    border-radius: 5px;
    border: #ccc 1px solid;

}

.header {
    /* text-align: center; */
    margin-bottom: 20px;
    max-width: 500px;
    width: 90%;
}

.logo {
    height: 60px;
}

.title {
    color: #666;
    font-size: 14px;
    margin: 10px 0px;
    font-size: 20px;
}

.branch {
    font-weight: bold;
    font-size: 20px;
    margin: 0px 0px;
}

.rating-card {
    display: flex;
    gap: 20px;
    padding: 15px 0;
    border-bottom: 1.5px solid #eee;
}

.rating-card:last-of-type {
    border-bottom: 0px solid #eee !important;
}

.avatar {
    /* background-color: #ddd; */
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border-radius: 50%;
    background-size: cover;
    /* fill the circle */
    background-position: center;
    /* center the image */
    background-repeat: no-repeat;
    border: 1px solid #ccc;
}

.info {
    flex: 1;
}

.name-row {
    display: flex;
    justify-content: space-between;
}

.role {
    font-size: 16px;
    color: #888;
    font-weight: bold;
}

.stars {
    margin: 8px 0;
    font-size: 20px;
    cursor: pointer;
}

.stars span {
    color: #ccc;
}

.stars span.active {
    color: #f4c430;
}

.comment {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.submit {
    cursor: pointer;
    margin-top: 20px;
    padding: 12px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    width: fit-content;
    align-self: end;

    padding: 12px 25px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 15px;
}

.btn_skip{
    cursor: pointer;
    padding: 12px;
    background-color: transparent;
    color: #317BEB;
    border-radius: 4px;
    width: 100%;
    align-self: end;

    padding: 6px;
    font-size: 20px;
    /* font-weight: bold; */
    margin-top: 5px;
    border: 3px solid #317BEB;
}

.btn_skip:hover{
    background-color: #317BEB29;
}

.loading {
    /* margin-top: 10px; */
    color: #007bff;
}

.error {
    margin-top: 10px;
    color: red;
}

.rating_logo {
    width: 25%;
    height: auto;
}

.h_4_edit{
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 20px;
}

.normal_star{
    height: 20px;
    margin-right: 5px;
}

.rate_avg{
    font-weight: bold;
}

.comment{
    color: #1d1d1d;
    border: 2px solid #CCCCCC;
    height: 80px;
    resize: vertical;
    min-height: 50px;
}

.comment::placeholder {
    color: #CCCCCC;
    font-size: 16px;
    font-weight: 400;
}

.ratting_star{
    height: 30px;
    margin-right: 5px;
}

.total_ratings {
    font-size: 13px;
    font-weight: bold;
    color: #6c6c6c;
}

.status-card{
    background-color: white;
    width: 100%;
    max-width: 500px;
    border-radius: 5px;
    border: 1px solid #ccc;
    padding: 10px 15px;
    margin-top: 10vh;
}

.already_rated_cont{
    align-items: center;
}

.close_the_tab{
    cursor: pointer;
    margin-top: 20px;
    padding: 12px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    width: fit-content;
    align-self: center;

    padding: 12px 25px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 15px;
    align-self: flex-end;
}

.status-card__subtitle{
    font-size: 20px;
    margin-bottom: 1em;
}

.none{
    display: none !important;
}

.grooming_deatils{
    font-size: 14px;
    color: #888;
}

.dev_phone_link{
    color: #007bff;
    font-weight: bold;
    text-decoration: none;

}

.dev_phone_link:hover{
    text-decoration: underline;
}

.rate_branch_cont{
    padding-top: 10vh;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* phone */

.btn_first_grooming{
    font-size: 20px;
    padding: 10px 35px;
    border-radius: 0px 5px 5px 0px;
}
/* .btn_first_grooming:focus {
  border: 3px solid #555;
} */

  /* .btn_first_grooming{
    outline-color: #fff;
    outline-style: none;
  } */

input{
    /* background-color: #d2dbf3; */
    background-color: #fff;
    /* border: 1px solid #647193; */
    border: 1px solid #ccc;
    border-right: 0px;
    border-radius: 5px 0px 0px 5px;
    padding: 5px 20px;
    font-size: 20px;
    /* -webkit-transition: 0.3s; */
    transition: 0.1s;
    outline: none;
}

.input:focus {
  border: 1px solid #317BEB;
  border-right: 0px;
}

.no_padding{
  padding: 0px 23px;
}

.hone_link{
  margin-bottom: 8px;
}



.err_single_line{
  color:red;
  font-size: 17px;
}

.waiting_line{
    padding: 10px 20px;
    background-color: #317BEB;
    font-weight: 500;
    font-size: 25px;
    position: fixed;
    left: 10px;
    bottom: 20px;
    border-radius: 3px;
    color: white;

    background-color: transparent;
    color: black;


}

.logout_{
  right: 10px;
  margin-top: 100px;
  left: auto;
  color: #317BEB;
  cursor: pointer;
  font-size: 16px;
  border: none;
  outline: none;
}

.logout_:hover{
  text-decoration: underline;
}

.rating_h1{
    font-size: 28px;
}

.bts_cont{
    justify-content: space-between;
}

.backk{
    background-color: transparent;
    border: 2px solid #007bff;
    color: #007bff;
}

.backk:hover{
    background-color: #007bff26;
}

/*Small devices (landscape phones, 576px and up)*/
@media (max-width: 800px) {
  .home_comp_cont{
    flex-direction: column;
  }
  .btn_home_cont{
    margin-bottom: 0px;
  }
  .btn_home_cont{
    margin-top: 0px;
  }
  .hone{
    margin-top: 26px;
  }
  input{
    width: 100%;
  }
}

@media (max-width: 500px) {
  .home_comp_cont{
    flex-direction: column;
    padding: 0px 10px;
  }

  .hone{
    font-size: 27px;
    margin-top: 40px;
  } 

  img{
    height: 120px;
    margin-right: 0px;
  }

  .btn_home_cont button{
    font-size: 20px;
  }

  .btn_first_grooming{
    padding: 10px 25px;
  }

  .no_padding{
    padding: 0px 12px;
  }

  .waiting_line__{
    font-size: 20px;
  }

}

</style>
